import React from "react";

interface IGoogleMapProps {
  address: string;
  height?: string | number;
  width?: string | number;
  className?: string;
}

const GoogleMap: React.FC<IGoogleMapProps> = ({
  address,
  height = 350,
  width = "100%",
  className,
}) => {
  const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    address
  )}&output=embed`;

  return (
    <iframe
      title="google-map"
      src={mapUrl}
      width={width}
      height={height}
      className={className}
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      id="see_map"
    />
  );
};

export default GoogleMap;
